import { render, staticRenderFns } from "./calendar2.vue?vue&type=template&id=ecbacea8&"
import script from "./calendar2.vue?vue&type=script&lang=js&"
export * from "./calendar2.vue?vue&type=script&lang=js&"
import style0 from "./calendar2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports